(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ask-a-question-faq"] && !Shopify.designMode) return;
  try {
    /* SmartBot handover ------------------------------------------------------
     The chat widget renders inside a shadow root on #smart-bot-container, so
     there is no global open() to call — we click its launcher. The app hashes
     its class names at build time, so match on a substring that survives a
     rebuild rather than the exact hash. The open chat window is
     [class*="chat-box-container"]; the launcher toggles, so check first and
     leave an already-open chat alone. */
  function askFaqChatRoot() {
    const host = document.getElementById('smart-bot-container');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function askFaqChatIsOpen(root) {
    const box = root.querySelector('[class*="chat-box-container"]');
    return !!box && box.offsetHeight > 0;
  }

  function askFaqOpenChat() {
    const root = askFaqChatRoot();
    if (!root) return false;
    if (askFaqChatIsOpen(root)) return true;
    const launcher =
      root.querySelector('[class*="chat-icon-primary-container"]') ||
      root.querySelector('[class*="chat-icon-container"]');
    if (!launcher) return false;
    launcher.click();
    return true;
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ask-faq-open]');
    if (openButton) {
      if (askFaqOpenChat()) return;
      const dialog = openButton.closest('[data-ask-faq]')?.querySelector('dialog');
      if (dialog) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-ask-faq-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('dialog.ask-faq__dialog')) event.target.close();
  });
  } catch(e) { console.error(e); }
})();

})();
